const WEBSITE_HOST = /^(.+)\.s3-website[.-]([a-z0-9-]+)\.amazonaws\.com$/i;
const S3_REST_HOST = /\.s3[.-][a-z0-9-]+\.amazonaws\.com$/i;

/** El endpoint s3-website es solo HTTP; el celular lo fuerza a HTTPS y falla. */
export function connectPublicOrigin(origin) {
  try {
    const parsed = new URL(origin);
    const website = parsed.hostname.match(WEBSITE_HOST);
    if (website) {
      return `https://${website[1]}.s3.${website[2]}.amazonaws.com`;
    }
  } catch {
    /* origin inválido */
  }
  return origin;
}

/** Links que el celular puede abrir: HTTPS 200 sobre un archivo real (index.html). */
export function connectPublicUrl(origin, slug, extra = {}) {
  const url = new URL(connectPublicOrigin(origin));
  url.pathname = S3_REST_HOST.test(url.hostname) ? '/index.html' : '/';
  url.search = '';
  url.hash = '';
  url.searchParams.set('c', String(slug || '').trim());
  const src = String(extra.src || '').trim();
  if (src) url.searchParams.set('src', src);
  if (extra.modoQr) url.searchParams.set('modo', 'qr');
  return url.toString();
}
